/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioTipoCuentaBancariaCV from './controladorVista/formularioTipoCuentaBancariaCV';
import TablaTipoCuentaBancariaCV from './controladorVista/tablaTipoCuentaBancariaCV';
import { estadoIncial, reductor } from './reductorTipoCuentaBancaria';

const TipoCuentaBancaria: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTipoCuentaBancariaCV />
        <FormualrioTipoCuentaBancariaCV />
    </ProveedorEstado>
);

export default TipoCuentaBancaria;
